<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Configure settings</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="form-group">
                <label for="Trigger">Deletition handling:</label><br />
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3">
                    <label class="form-check-label" for="inlineRadio3">Ignore</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3">
                    <label class="form-check-label" for="inlineRadio3">Delete</label>
                </div>
            </div>

            <div class="form-group">
                <label for="Trigger">Error handling:</label><br />
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3">
                    <label class="form-check-label" for="inlineRadio3">Continue on error</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3">
                    <label class="form-check-label" for="inlineRadio3">Stop on error</label>
                </div>
            </div>

            <div class="form-group">
                <label for="Trigger">Throttling:</label><br />
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio3" value="option3">
                    <label class="form-check-label" for="inlineRadio3">Enable throttling</label>
                </div>
            </div>

            <a href="/#/admin/integrations/pipelines/dashboard/1" class="btn btn-primary btn-lg">Save</a>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, mixins } from 'vue-facing-decorator';
import PageBase from "@common/PageBase";

@Component
export default class DashboardPage extends mixins(PageBase) {
        mounted() {
            this.setTitle("Configure mapping");
        }
}
</script>

<style scoped>
</style>